import { Map as MapImmutable } from 'immutable';
import {
  GET_EXTERNAL_MODULES_START,
  GET_EXTERNAL_MODULES_SUCCESS,
  GET_EXTERNAL_MODULES_FAILURE,
} from './events';
import { CLEAR_USER_DETAIL } from '../../events';

const initialState = new MapImmutable({
  modules: [],
  loaded: false,
  requesting: false,
});

const actionHandlers = {};

actionHandlers[GET_EXTERNAL_MODULES_START] = state => state
  .set('requesting', true)
  .delete('error');

actionHandlers[GET_EXTERNAL_MODULES_SUCCESS] = (state, action) => state
  .set('requesting', false)
  .set('loaded', true)
  .set('modules', action.modules);

// A failed fetch leaves the list empty so the nav simply shows no external modules.
actionHandlers[GET_EXTERNAL_MODULES_FAILURE] = (state, action) => state
  .set('requesting', false)
  .set('loaded', true)
  .set('modules', [])
  .set('error', action.error);

actionHandlers[CLEAR_USER_DETAIL] = () => initialState;

export default (state = initialState, action) => {
  if (actionHandlers[action.type] !== undefined) {
    return actionHandlers[action.type](state, action) || state;
  }
  return state;
};
